<div class="nm-wrapper" [class.nm-wrapper--disabled]="_disabled">
  <!-- Trigger -->
  <div
    class="nm-trigger"
    role="button"
    tabindex="0"
    (click)="openPanel()"
    (keydown.enter)="openPanel()"
    (keydown.space)="openPanel()"
    [attr.aria-expanded]="_isOpen()"
  >
    <div class="nm-trigger__body">
      @if (showPlaceholder) {
      <span class="nm-placeholder">{{ placeholder }}</span>
      } @else if (multiple && display === 'chip') {
      <div class="nm-chips">
        @for (chip of visibleChips; track getOptionValue(chip)) {
        <span class="nm-chip">
          {{ getOptionLabel(chip) }}
          <button
            type="button"
            class="nm-chip__remove"
            (click)="removeChip(getOptionValue(chip), $event)"
            aria-label="Remover"
          >
            <i class="pi pi-times"></i>
          </button>
        </span>
        } @if (hiddenCount > 0) {
        <span class="nm-chip nm-chip--count">+{{ hiddenCount }}</span>
        }
      </div>
      } @else if (multiple) {
      <span class="nm-value-text">{{ summaryLabel }}</span>
      } @else {
      <span class="nm-value-text">{{ singleLabel }}</span>
      }
    </div>
    <i
      class="pi pi-chevron-down nm-chevron"
      [class.nm-chevron--open]="_isOpen()"
    ></i>
  </div>
</div>

<ng-template #overlayPortal>
  <div class="nm-overlay">
    <div
      class="nm-backdrop"
      [class.nm-backdrop--closing]="_isClosing()"
      role="button"
      tabindex="-1"
      aria-label="Fechar"
      (click)="close()"
      (keydown.enter)="close()"
      (keydown.escape)="close()"
    ></div>

    <div
      class="nm-panel"
      role="dialog"
      aria-modal="true"
      [class.nm-panel--closing]="_isClosing()"
    >
      <div class="nm-panel__header">
        <span class="nm-panel__title">{{ placeholder }}</span>
        <button
          type="button"
          class="nm-panel__close"
          (click)="close()"
          aria-label="Fechar"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>

      @if (showHeader) {
      <div class="nm-search">
        <i class="pi pi-search nm-search__icon"></i>
        <input
          type="text"
          [ngModel]="_searchTerm()"
          (ngModelChange)="_searchTerm.set($event)"
          class="nm-search__input"
          placeholder="Pesquisar..."
          autocomplete="off"
        />
      </div>
      }

      <div class="nm-options">
        @for (option of filteredOptions; track getOptionValue(option)) {
        <div
          class="nm-option"
          role="option"
          tabindex="0"
          [class.nm-option--selected]="isSelected(option)"
          [attr.aria-selected]="isSelected(option)"
          (click)="toggleOption(option)"
          (keydown.enter)="toggleOption(option)"
          (keydown.space)="toggleOption(option)"
        >
          <div
            class="nm-checkbox"
            [class.nm-checkbox--checked]="isSelected(option)"
          >
            @if (multiple) { @if (isSelected(option)) {
            <i class="pi pi-check"></i>
            } } @else {
            <div
              class="nm-radio"
              [class.nm-radio--checked]="isSelected(option)"
            ></div>
            }
          </div>
          <ng-container
            *ngTemplateOutlet="
              itemTemplate || defaultItemTemplate;
              context: { $implicit: option }
            "
          ></ng-container>
          <ng-template #defaultItemTemplate>
            <span class="nm-option__label">{{ getOptionLabel(option) }}</span>
          </ng-template>
        </div>
        } @if (filteredOptions.length === 0) {
        <div class="nm-empty">Nenhum item encontrado</div>
        }
      </div>

      @if (multiple) {
      <div class="nm-footer">
        <button type="button" class="nm-btn-close" (click)="close()">
          Confirmar ({{ _selectedValues.length }})
        </button>
      </div>
      }
    </div>
  </div>
</ng-template>
